import { IncentiveOfferSellerParticipationLimits } from 'modules/incentivesMarket/types';

export const defaultSellerParticipationLimits: IncentiveOfferSellerParticipationLimits =
  {
    allowSellAll: true,
    maxPercentUnvested: 100,
    maxUnits: 0,
    maxPercentUnits: 0,
    maxPhantoms: 0,
    maxPercentPhantoms: 0,
    maxStocks: 0,
    maxPercentStocks: 0,
    maxWarrants: 0,
    maxPercentWarrants: 0,
    maxAmount: 0,
  };

export const PREVIEW_AVAILABLE_UNITS = 1838;
